import http, {pickData} from './http';
import {METADATA_BASE} from './paths';
import {withPerm} from './perm';

// 단어 데이터 목록 조회
export const getWordDataList = withPerm(async () => {
  const response = await http.get(`${METADATA_BASE}/wordData`);
  return response.data;
}, 'GET', `${METADATA_BASE}/wordData`);

// 단어 데이터 생성
export const createWordData = withPerm(async (wordData) => {
  const response = await http.post(`${METADATA_BASE}/wordData`, wordData);
  return response.data;
}, 'POST', `${METADATA_BASE}/wordData`);

// LLM 기반 단어 제안(영문명/설명/약어)
export const suggestWord = withPerm(async ({ wordNm, domainClsfNm }) => {
  const res = await http.post(`${METADATA_BASE}/wordData/suggest`, { wordNm, domainClsfNm });
  return pickData(res);
}, 'POST', `${METADATA_BASE}/wordData/suggest`);

// 단어 데이터 단건 삭제 (백엔드와 일치)
export const deleteWordData = withPerm(async (wordDataId) => {
  const response = await http.delete(`${METADATA_BASE}/wordData/${wordDataId}`);
  return response.data;
}, 'DELETE', `${METADATA_BASE}/wordData/{wordDataId}`);

// 단어 데이터 엑셀 일괄 등록
export const createWordDataBatch = withPerm(async (wordDataList) => {
  const response = await http.post(`${METADATA_BASE}/wordData/batch`, wordDataList);
  return response.data;
}, 'POST', `${METADATA_BASE}/wordData/batch`);

// 단어 데이터 일괄 삭제(헬퍼): 권한은 단건 삭제 권한으로 판단
export async function deleteWordDataBatch(idList = []) {
  if (!Array.isArray(idList) || idList.length === 0) return { deleted: 0 };
  let deleted = 0; const errors = [];
  for (const id of idList) {
    try { await deleteWordData(id); deleted++; }
    catch (e) { errors.push({ id, status: e?.response?.status, message: e?.message }); }
  }
  return { deleted, errors };
}
